var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficialRates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "official_rates",
    "data-name": "official rates",
    transform: "translate(-11 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(11 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    className: "cls-1",
    d: "M71.618,109.934a1.022,1.022,0,0,0,1.3-.21l3.529-4.47,3.735,3.123a1.012,1.012,0,0,0,.741.222.987.987,0,0,0,.677-.341l6.194-7.7.224,2.576c.055.654.763.761,1,.745a.854.854,0,0,0,.859-.868l-.393-4.529a.9.9,0,0,0-1-.745l-5.225.341a.852.852,0,0,0-.859.868.9.9,0,0,0,1,.745L86.37,99.5l-5.678,7.053-3.744-3.13a1,1,0,0,0-.741-.222.961.961,0,0,0-.677.349l-4.156,5.262A.744.744,0,0,0,71.618,109.934Z",
    transform: "translate(-67.28 -92.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    className: "cls-1",
    d: "M34,33H13V12a1,1,0,1,0-2,0V34a1,1,0,0,0,1,1H34a1,1,0,1,0,0-2Z",
    transform: "translate(-11 -11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialRates);
export default __webpack_public_path__ + "static/media/OfficialRates.08aced67.svg";
export { ForwardRef as ReactComponent };